import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Form from "../../../../shared/components/Form"
import Input from "../../../../shared/components/Input";
import { formatDate } from "../../../../util/date";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const STATUSES = [
  {
    value: "Pending",
    label: "Pending",
  },
  {
    value: "Partially Paid",
    label: "Partially Paid",
  },
  {
    value: "Fully Paid",
    label: "Fully Paid",
  },
  {
    value: "Canceled",
    label: "Canceled",
  },
]

const AttendeeForm = ({ defaultValues = {}, onChange, onSubmit, printCertificate }) => {
  const {
    personal_name,
    middle_name,
    last_name,
    date_of_birth,
    email,
    mobile_number,
    address,
    company,
    position,
    company_address,
    status,
    payments = []
  } = defaultValues;

  console.log("Attendee Payments", payments);
  return (
    <Form onSubmit={onSubmit}>
      <div className="form__group">
        <div className="form__row">
          <div className="form__row--item">
            <Input
              defaultValue={personal_name}
              label="Personal Name" isRequired
              onChange={(value) => {
                onChange("personal_name", value);
              }}
            />
          </div>
        </div>

        <div className="form__row">
          <div className="form__row--item">
            <Input
              defaultValue={middle_name}
              label="Middle Name"
              onChange={(value) => {
                onChange("middle_name", value);
              }}
            />
          </div>
        </div>

        <div className="form__row">
          <div className="form__row--item">
            <Input defaultValue={last_name} label="Last Name" isRequired onChange={(value) => {
                onChange("last_name", value);
              }} />
          </div>
        </div>

        <div className="form__row">
          <div className="form__row--item">
            <Input
              type="select"
              options={STATUSES}
              defaultValue={status}
              label="Status"
              isRequired
              onChange={(value) => {
                onChange("status", value);
              }}
            />
          </div>
        </div>

        <div className="form__row">
          <div className="form__row--item">
            <Input defaultValue={email} label="Email" isRequired onChange={(value) => {
                onChange("email", value);
              }} />
          </div>
        </div>

        <div className="form__row">
          <div className="form__row--item">
            <Input defaultValue={mobile_number} label="Mobile Number" onChange={(value) => {
                onChange("mobile_number", value);
              }} />
          </div>
        </div>

        <div className="form__row">
          <div className="form__row--item">
            <Input defaultValue={date_of_birth ? formatDate(date_of_birth, { isoFormat: true }) : undefined} label="DOB" type="date" onChange={(value) => {
                onChange("date_of_birth", value);
              }} />
          </div>
        </div>

        <div className="form__row">
          <div className="form__row--item">
            <Input defaultValue={address} label="Address" type="textarea" onChange={(value) => {
                onChange("address", value);
              }} />
          </div>
        </div>
      </div>

      <div className="form__group">
        <div className="form__title">
          <div>Company Details</div>
        </div>
        <div className="form__row">
          <div className="form__row--item">
            <Input defaultValue={company} label="Name" onChange={(value) => {
                onChange("company", value);
              }} />
          </div>
        </div>

        <div className="form__row">
          <div className="form__row--item">
            <Input defaultValue={position} label="Position" onChange={(value) => {
                onChange("position", value);
              }} />
          </div>
        </div>

        <div className="form__row">
          <div className="form__row--item">
            <Input defaultValue={company_address} label="Address" type="textarea" onChange={(value) => {
                onChange("company_address", value);
              }} />
          </div>
        </div>
      </div>

      <div className="form__group">
        <div className="form__title">
          <div>Payments Details</div>
          <div className="form__title--configs">
            <div className="form__title--config" onClick={() => {
              onChange("payments", [
                ...payments,
                {
                  type: "Cash",
                  value: 0,
                }
              ])
            }}>
              <FontAwesomeIcon icon={faPlus} />
            </div>
          </div>
        </div>
        {payments.map((paymentItem, paymentIndex) => (
          <div className="form__row">
            <div className="form__row--item">
              <Input defaultValue={String(paymentItem.value || "")} label={paymentItem.type} onChange={(value) => {
                  const updatedPayments = [...payments].map((copyItem, copyIndex) => {
                    if (paymentIndex !== copyIndex) return copyItem;

                    return {
                      ...copyItem,
                      value: parseFloat(value),
                    }
                  });
                  onChange("payments", updatedPayments);
                }} />
            </div>
          </div>
        ))}
      </div>
    </Form>
  )
}

export default AttendeeForm;